import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { icons, GRAY, Checkbox, Radio } from '@applyboard/ui-components';
import { QUESTION_FORMATS } from "./consts";
var QuestionIcon = function QuestionIcon(_ref) {
  var questionFormat = _ref.questionFormat;
  var CalendarIcon = icons.CalendarDateStartOutline,
    LinkIcon = icons.LinkOutline,
    NumberIcon = icons.Number,
    TextIcon = icons.Text;
  var iconProps = {
    fill: GRAY[15],
    role: 'img'
  };

  // disabled components used in lieu of an icon since no icon is provided/available
  if (questionFormat === QUESTION_FORMATS.checkbox) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      disabled: true,
      checked: true,
      role: "img",
      "aria-label": "Select one or more of these results:"
    });
  }
  if (questionFormat === QUESTION_FORMATS.dropdown) {
    return /*#__PURE__*/React.createElement(Radio, {
      disabled: true,
      checked: true,
      role: "img",
      "aria-label": "Select one of these results:"
    });
  }
  if (questionFormat === QUESTION_FORMATS.date) {
    return /*#__PURE__*/React.createElement(CalendarIcon, _extends({
      "aria-hidden": true
    }, iconProps));
  }
  if (questionFormat === QUESTION_FORMATS.url) {
    return /*#__PURE__*/React.createElement(LinkIcon, _extends({
      "aria-hidden": true
    }, iconProps));
  }
  if (questionFormat === QUESTION_FORMATS.number) {
    return /*#__PURE__*/React.createElement(NumberIcon, _extends({
      "aria-hidden": true
    }, iconProps));
  }
  if (questionFormat === QUESTION_FORMATS.longAnswer || questionFormat === QUESTION_FORMATS.shortAnswer) {
    return /*#__PURE__*/React.createElement(TextIcon, _extends({
      "aria-hidden": true
    }, iconProps));
  }
  return null;
};
export default QuestionIcon;